import { ICategory, IService, ServiceState } from '../../rz-status_models';
import { useFilter } from '../contextProviders/FilterContext';
import StateIcon from './StateIcon';

export default function({item, counter = false}:{item: ICategory | IService, counter?: boolean}) {
  const { filter } = useFilter();
  
  const state: ServiceState= isService(item) ? (item as IService).currentStatus : filter.reduce((acc, key) => (item as ICategory).states[key] > 0 ? Math.max(acc, key) : acc, 0);
  if(counter && state > ServiceState.Available && !isService(item)) 
    return <span className="counter" title={`${item.states[1]} ${item.states[1] == 1 ? "Anwendung" : "Anwendungen"} eingeschränkt, ${item.states[2]} nicht verfügbar, ${item.states[3]} in Wartung`}>{Object.entries((item as ICategory).states).map(([state, num]) => num).filter((_, i) => filter.includes(i) && i > 0).reduce((acc, num) => acc + num, 0)}</span>
  return <StateIcon state={state} />
}

function isService(item: ICategory | IService): item is IService {
  return (item as IService).currentStatus !== undefined;
}